export class DetailsError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'DetailsError';
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class EpisodesError extends DetailsError {
  constructor(type: 'source' | 'title', id: string) {
    super(`No episodes found for ${type} "${id}"`);
    this.name = 'EpisodesError';
  }
}

export class SeasonsError extends DetailsError {
  constructor(type: 'source' | 'title', id: string) {
    super(`No seasons found for ${type} "${id}"`);
    this.name = 'SeasonsError';
  }
}

export class SourceError extends DetailsError {
  constructor(providerId: string) {
    super(`No source found for provider "${providerId}"`);
    this.name = 'SourceError';
  }
}

export class SourceParsingError extends DetailsError {
  constructor(message: string) {
    super(message);
    this.name = 'SourceParsingError';
  }
}
